/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthCallbackRouteImport } from './routes/authCallback'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthUpgradeRouteImport } from './routes/_auth.upgrade'
import { Route as AuthSettingsRouteImport } from './routes/_auth.settings'
import { Route as AuthOrganizationsRouteImport } from './routes/_auth.organizations'
import { Route as AuthSettingsIndexRouteImport } from './routes/_auth.settings.index'
import { Route as AuthOrganizationsIndexRouteImport } from './routes/_auth.organizations.index'
import { Route as AuthAgentsIndexRouteImport } from './routes/_auth.agents.index'
import { Route as AuthSettingsWorkspaceRouteImport } from './routes/_auth.settings.workspace'
import { Route as AuthSettingsSecurityRouteImport } from './routes/_auth.settings.security'
import { Route as AuthSettingsProfileRouteImport } from './routes/_auth.settings.profile'
import { Route as AuthSettingsPlansRouteImport } from './routes/_auth.settings.plans'
import { Route as AuthSettingsBillingRouteImport } from './routes/_auth.settings.billing'
import { Route as AuthSettingsApiRouteImport } from './routes/_auth.settings.api'
import { Route as AuthOrganizationsNewRouteImport } from './routes/_auth.organizations.new'
import { Route as AuthIntegrationsExcelRouteImport } from './routes/_auth.integrations.excel'
import { Route as AuthAgentsNewRouteImport } from './routes/_auth.agents.new'
import { Route as AuthAgentsAgentIdRouteImport } from './routes/_auth.agents.$agentId'
import { Route as AuthAgentsAgentIdIndexRouteImport } from './routes/_auth.agents.$agentId.index'
import { Route as AuthDetailsAgentsAgentIdRouteImport } from './routes/_auth.details.agents.$agentId'
import { Route as AuthAgentsAgentIdIntegrationRouteImport } from './routes/_auth.agents.$agentId.integration'
import { Route as AuthAgentsAgentIdInboxRouteImport } from './routes/_auth.agents.$agentId.inbox'
import { Route as AuthAgentsAgentIdAnalyticsRouteImport } from './routes/_auth.agents.$agentId.analytics'
import { Route as AuthDetailsAgentsAgentIdEmptyRouteImport } from './routes/_auth.details.agents.$agentId.empty'
import { Route as AuthDetailsAgentsAgentIdRunsRunIdRouteImport } from './routes/_auth.details.agents.$agentId.runs.$runId'

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/authCallback',
  path: '/authCallback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthUpgradeRoute = AuthUpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOrganizationsRoute = AuthOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsIndexRoute = AuthSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthOrganizationsIndexRoute = AuthOrganizationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOrganizationsRoute,
} as any)
const AuthAgentsIndexRoute = AuthAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsWorkspaceRoute = AuthSettingsWorkspaceRouteImport.update({
  id: '/workspace',
  path: '/workspace',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsSecurityRoute = AuthSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsProfileRoute = AuthSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsPlansRoute = AuthSettingsPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsBillingRoute = AuthSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsApiRoute = AuthSettingsApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthOrganizationsNewRoute = AuthOrganizationsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthOrganizationsRoute,
} as any)
const AuthIntegrationsExcelRoute = AuthIntegrationsExcelRouteImport.update({
  id: '/integrations/excel',
  path: '/integrations/excel',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentsNewRoute = AuthAgentsNewRouteImport.update({
  id: '/agents/new',
  path: '/agents/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentsAgentIdRoute = AuthAgentsAgentIdRouteImport.update({
  id: '/agents/$agentId',
  path: '/agents/$agentId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentsAgentIdIndexRoute = AuthAgentsAgentIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAgentsAgentIdRoute,
} as any)
const AuthDetailsAgentsAgentIdRoute =
  AuthDetailsAgentsAgentIdRouteImport.update({
    id: '/details/agents/$agentId',
    path: '/details/agents/$agentId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAgentsAgentIdIntegrationRoute =
  AuthAgentsAgentIdIntegrationRouteImport.update({
    id: '/integration',
    path: '/integration',
    getParentRoute: () => AuthAgentsAgentIdRoute,
  } as any)
const AuthAgentsAgentIdInboxRoute = AuthAgentsAgentIdInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthAgentsAgentIdRoute,
} as any)
const AuthAgentsAgentIdAnalyticsRoute =
  AuthAgentsAgentIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthAgentsAgentIdRoute,
  } as any)
const AuthDetailsAgentsAgentIdEmptyRoute =
  AuthDetailsAgentsAgentIdEmptyRouteImport.update({
    id: '/empty',
    path: '/empty',
    getParentRoute: () => AuthDetailsAgentsAgentIdRoute,
  } as any)
const AuthDetailsAgentsAgentIdRunsRunIdRoute =
  AuthDetailsAgentsAgentIdRunsRunIdRouteImport.update({
    id: '/runs/$runId',
    path: '/runs/$runId',
    getParentRoute: () => AuthDetailsAgentsAgentIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/authCallback': typeof AuthCallbackRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/organizations': typeof AuthOrganizationsRouteWithChildren
  '/settings': typeof AuthSettingsRouteWithChildren
  '/upgrade': typeof AuthUpgradeRoute
  '/agents/$agentId': typeof AuthAgentsAgentIdRouteWithChildren
  '/agents/new': typeof AuthAgentsNewRoute
  '/integrations/excel': typeof AuthIntegrationsExcelRoute
  '/organizations/new': typeof AuthOrganizationsNewRoute
  '/settings/api': typeof AuthSettingsApiRoute
  '/settings/billing': typeof AuthSettingsBillingRoute
  '/settings/plans': typeof AuthSettingsPlansRoute
  '/settings/profile': typeof AuthSettingsProfileRoute
  '/settings/security': typeof AuthSettingsSecurityRoute
  '/settings/workspace': typeof AuthSettingsWorkspaceRoute
  '/agents': typeof AuthAgentsIndexRoute
  '/organizations/': typeof AuthOrganizationsIndexRoute
  '/settings/': typeof AuthSettingsIndexRoute
  '/agents/$agentId/analytics': typeof AuthAgentsAgentIdAnalyticsRoute
  '/agents/$agentId/inbox': typeof AuthAgentsAgentIdInboxRoute
  '/agents/$agentId/integration': typeof AuthAgentsAgentIdIntegrationRoute
  '/details/agents/$agentId': typeof AuthDetailsAgentsAgentIdRouteWithChildren
  '/agents/$agentId/': typeof AuthAgentsAgentIdIndexRoute
  '/details/agents/$agentId/empty': typeof AuthDetailsAgentsAgentIdEmptyRoute
  '/details/agents/$agentId/runs/$runId': typeof AuthDetailsAgentsAgentIdRunsRunIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/authCallback': typeof AuthCallbackRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/upgrade': typeof AuthUpgradeRoute
  '/agents/new': typeof AuthAgentsNewRoute
  '/integrations/excel': typeof AuthIntegrationsExcelRoute
  '/organizations/new': typeof AuthOrganizationsNewRoute
  '/settings/api': typeof AuthSettingsApiRoute
  '/settings/billing': typeof AuthSettingsBillingRoute
  '/settings/plans': typeof AuthSettingsPlansRoute
  '/settings/profile': typeof AuthSettingsProfileRoute
  '/settings/security': typeof AuthSettingsSecurityRoute
  '/settings/workspace': typeof AuthSettingsWorkspaceRoute
  '/agents': typeof AuthAgentsIndexRoute
  '/organizations': typeof AuthOrganizationsIndexRoute
  '/settings': typeof AuthSettingsIndexRoute
  '/agents/$agentId/analytics': typeof AuthAgentsAgentIdAnalyticsRoute
  '/agents/$agentId/inbox': typeof AuthAgentsAgentIdInboxRoute
  '/agents/$agentId/integration': typeof AuthAgentsAgentIdIntegrationRoute
  '/details/agents/$agentId': typeof AuthDetailsAgentsAgentIdRouteWithChildren
  '/agents/$agentId': typeof AuthAgentsAgentIdIndexRoute
  '/details/agents/$agentId/empty': typeof AuthDetailsAgentsAgentIdEmptyRoute
  '/details/agents/$agentId/runs/$runId': typeof AuthDetailsAgentsAgentIdRunsRunIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/authCallback': typeof AuthCallbackRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/_auth/organizations': typeof AuthOrganizationsRouteWithChildren
  '/_auth/settings': typeof AuthSettingsRouteWithChildren
  '/_auth/upgrade': typeof AuthUpgradeRoute
  '/_auth/agents/$agentId': typeof AuthAgentsAgentIdRouteWithChildren
  '/_auth/agents/new': typeof AuthAgentsNewRoute
  '/_auth/integrations/excel': typeof AuthIntegrationsExcelRoute
  '/_auth/organizations/new': typeof AuthOrganizationsNewRoute
  '/_auth/settings/api': typeof AuthSettingsApiRoute
  '/_auth/settings/billing': typeof AuthSettingsBillingRoute
  '/_auth/settings/plans': typeof AuthSettingsPlansRoute
  '/_auth/settings/profile': typeof AuthSettingsProfileRoute
  '/_auth/settings/security': typeof AuthSettingsSecurityRoute
  '/_auth/settings/workspace': typeof AuthSettingsWorkspaceRoute
  '/_auth/agents/': typeof AuthAgentsIndexRoute
  '/_auth/organizations/': typeof AuthOrganizationsIndexRoute
  '/_auth/settings/': typeof AuthSettingsIndexRoute
  '/_auth/agents/$agentId/analytics': typeof AuthAgentsAgentIdAnalyticsRoute
  '/_auth/agents/$agentId/inbox': typeof AuthAgentsAgentIdInboxRoute
  '/_auth/agents/$agentId/integration': typeof AuthAgentsAgentIdIntegrationRoute
  '/_auth/details/agents/$agentId': typeof AuthDetailsAgentsAgentIdRouteWithChildren
  '/_auth/agents/$agentId/': typeof AuthAgentsAgentIdIndexRoute
  '/_auth/details/agents/$agentId/empty': typeof AuthDetailsAgentsAgentIdEmptyRoute
  '/_auth/details/agents/$agentId/runs/$runId': typeof AuthDetailsAgentsAgentIdRunsRunIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/authCallback'
    | '/login'
    | '/logout'
    | '/organizations'
    | '/settings'
    | '/upgrade'
    | '/agents/$agentId'
    | '/agents/new'
    | '/integrations/excel'
    | '/organizations/new'
    | '/settings/api'
    | '/settings/billing'
    | '/settings/plans'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/workspace'
    | '/agents'
    | '/organizations/'
    | '/settings/'
    | '/agents/$agentId/analytics'
    | '/agents/$agentId/inbox'
    | '/agents/$agentId/integration'
    | '/details/agents/$agentId'
    | '/agents/$agentId/'
    | '/details/agents/$agentId/empty'
    | '/details/agents/$agentId/runs/$runId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/authCallback'
    | '/login'
    | '/logout'
    | '/upgrade'
    | '/agents/new'
    | '/integrations/excel'
    | '/organizations/new'
    | '/settings/api'
    | '/settings/billing'
    | '/settings/plans'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/workspace'
    | '/agents'
    | '/organizations'
    | '/settings'
    | '/agents/$agentId/analytics'
    | '/agents/$agentId/inbox'
    | '/agents/$agentId/integration'
    | '/details/agents/$agentId'
    | '/agents/$agentId'
    | '/details/agents/$agentId/empty'
    | '/details/agents/$agentId/runs/$runId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/authCallback'
    | '/login'
    | '/logout'
    | '/_auth/organizations'
    | '/_auth/settings'
    | '/_auth/upgrade'
    | '/_auth/agents/$agentId'
    | '/_auth/agents/new'
    | '/_auth/integrations/excel'
    | '/_auth/organizations/new'
    | '/_auth/settings/api'
    | '/_auth/settings/billing'
    | '/_auth/settings/plans'
    | '/_auth/settings/profile'
    | '/_auth/settings/security'
    | '/_auth/settings/workspace'
    | '/_auth/agents/'
    | '/_auth/organizations/'
    | '/_auth/settings/'
    | '/_auth/agents/$agentId/analytics'
    | '/_auth/agents/$agentId/inbox'
    | '/_auth/agents/$agentId/integration'
    | '/_auth/details/agents/$agentId'
    | '/_auth/agents/$agentId/'
    | '/_auth/details/agents/$agentId/empty'
    | '/_auth/details/agents/$agentId/runs/$runId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authCallback': {
      id: '/authCallback'
      path: '/authCallback'
      fullPath: '/authCallback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/upgrade': {
      id: '/_auth/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof AuthUpgradeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/organizations': {
      id: '/_auth/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthOrganizationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/': {
      id: '/_auth/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthSettingsIndexRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/organizations/': {
      id: '/_auth/organizations/'
      path: '/'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AuthOrganizationsIndexRouteImport
      parentRoute: typeof AuthOrganizationsRoute
    }
    '/_auth/agents/': {
      id: '/_auth/agents/'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AuthAgentsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/workspace': {
      id: '/_auth/settings/workspace'
      path: '/workspace'
      fullPath: '/settings/workspace'
      preLoaderRoute: typeof AuthSettingsWorkspaceRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/security': {
      id: '/_auth/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthSettingsSecurityRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/profile': {
      id: '/_auth/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthSettingsProfileRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/plans': {
      id: '/_auth/settings/plans'
      path: '/plans'
      fullPath: '/settings/plans'
      preLoaderRoute: typeof AuthSettingsPlansRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/billing': {
      id: '/_auth/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthSettingsBillingRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/api': {
      id: '/_auth/settings/api'
      path: '/api'
      fullPath: '/settings/api'
      preLoaderRoute: typeof AuthSettingsApiRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/organizations/new': {
      id: '/_auth/organizations/new'
      path: '/new'
      fullPath: '/organizations/new'
      preLoaderRoute: typeof AuthOrganizationsNewRouteImport
      parentRoute: typeof AuthOrganizationsRoute
    }
    '/_auth/integrations/excel': {
      id: '/_auth/integrations/excel'
      path: '/integrations/excel'
      fullPath: '/integrations/excel'
      preLoaderRoute: typeof AuthIntegrationsExcelRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents/new': {
      id: '/_auth/agents/new'
      path: '/agents/new'
      fullPath: '/agents/new'
      preLoaderRoute: typeof AuthAgentsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents/$agentId': {
      id: '/_auth/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AuthAgentsAgentIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents/$agentId/': {
      id: '/_auth/agents/$agentId/'
      path: '/'
      fullPath: '/agents/$agentId/'
      preLoaderRoute: typeof AuthAgentsAgentIdIndexRouteImport
      parentRoute: typeof AuthAgentsAgentIdRoute
    }
    '/_auth/details/agents/$agentId': {
      id: '/_auth/details/agents/$agentId'
      path: '/details/agents/$agentId'
      fullPath: '/details/agents/$agentId'
      preLoaderRoute: typeof AuthDetailsAgentsAgentIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents/$agentId/integration': {
      id: '/_auth/agents/$agentId/integration'
      path: '/integration'
      fullPath: '/agents/$agentId/integration'
      preLoaderRoute: typeof AuthAgentsAgentIdIntegrationRouteImport
      parentRoute: typeof AuthAgentsAgentIdRoute
    }
    '/_auth/agents/$agentId/inbox': {
      id: '/_auth/agents/$agentId/inbox'
      path: '/inbox'
      fullPath: '/agents/$agentId/inbox'
      preLoaderRoute: typeof AuthAgentsAgentIdInboxRouteImport
      parentRoute: typeof AuthAgentsAgentIdRoute
    }
    '/_auth/agents/$agentId/analytics': {
      id: '/_auth/agents/$agentId/analytics'
      path: '/analytics'
      fullPath: '/agents/$agentId/analytics'
      preLoaderRoute: typeof AuthAgentsAgentIdAnalyticsRouteImport
      parentRoute: typeof AuthAgentsAgentIdRoute
    }
    '/_auth/details/agents/$agentId/empty': {
      id: '/_auth/details/agents/$agentId/empty'
      path: '/empty'
      fullPath: '/details/agents/$agentId/empty'
      preLoaderRoute: typeof AuthDetailsAgentsAgentIdEmptyRouteImport
      parentRoute: typeof AuthDetailsAgentsAgentIdRoute
    }
    '/_auth/details/agents/$agentId/runs/$runId': {
      id: '/_auth/details/agents/$agentId/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/details/agents/$agentId/runs/$runId'
      preLoaderRoute: typeof AuthDetailsAgentsAgentIdRunsRunIdRouteImport
      parentRoute: typeof AuthDetailsAgentsAgentIdRoute
    }
  }
}

interface AuthOrganizationsRouteChildren {
  AuthOrganizationsNewRoute: typeof AuthOrganizationsNewRoute
  AuthOrganizationsIndexRoute: typeof AuthOrganizationsIndexRoute
}

const AuthOrganizationsRouteChildren: AuthOrganizationsRouteChildren = {
  AuthOrganizationsNewRoute: AuthOrganizationsNewRoute,
  AuthOrganizationsIndexRoute: AuthOrganizationsIndexRoute,
}

const AuthOrganizationsRouteWithChildren =
  AuthOrganizationsRoute._addFileChildren(AuthOrganizationsRouteChildren)

interface AuthSettingsRouteChildren {
  AuthSettingsApiRoute: typeof AuthSettingsApiRoute
  AuthSettingsBillingRoute: typeof AuthSettingsBillingRoute
  AuthSettingsPlansRoute: typeof AuthSettingsPlansRoute
  AuthSettingsProfileRoute: typeof AuthSettingsProfileRoute
  AuthSettingsSecurityRoute: typeof AuthSettingsSecurityRoute
  AuthSettingsWorkspaceRoute: typeof AuthSettingsWorkspaceRoute
  AuthSettingsIndexRoute: typeof AuthSettingsIndexRoute
}

const AuthSettingsRouteChildren: AuthSettingsRouteChildren = {
  AuthSettingsApiRoute: AuthSettingsApiRoute,
  AuthSettingsBillingRoute: AuthSettingsBillingRoute,
  AuthSettingsPlansRoute: AuthSettingsPlansRoute,
  AuthSettingsProfileRoute: AuthSettingsProfileRoute,
  AuthSettingsSecurityRoute: AuthSettingsSecurityRoute,
  AuthSettingsWorkspaceRoute: AuthSettingsWorkspaceRoute,
  AuthSettingsIndexRoute: AuthSettingsIndexRoute,
}

const AuthSettingsRouteWithChildren = AuthSettingsRoute._addFileChildren(
  AuthSettingsRouteChildren,
)

interface AuthAgentsAgentIdRouteChildren {
  AuthAgentsAgentIdAnalyticsRoute: typeof AuthAgentsAgentIdAnalyticsRoute
  AuthAgentsAgentIdInboxRoute: typeof AuthAgentsAgentIdInboxRoute
  AuthAgentsAgentIdIntegrationRoute: typeof AuthAgentsAgentIdIntegrationRoute
  AuthAgentsAgentIdIndexRoute: typeof AuthAgentsAgentIdIndexRoute
}

const AuthAgentsAgentIdRouteChildren: AuthAgentsAgentIdRouteChildren = {
  AuthAgentsAgentIdAnalyticsRoute: AuthAgentsAgentIdAnalyticsRoute,
  AuthAgentsAgentIdInboxRoute: AuthAgentsAgentIdInboxRoute,
  AuthAgentsAgentIdIntegrationRoute: AuthAgentsAgentIdIntegrationRoute,
  AuthAgentsAgentIdIndexRoute: AuthAgentsAgentIdIndexRoute,
}

const AuthAgentsAgentIdRouteWithChildren =
  AuthAgentsAgentIdRoute._addFileChildren(AuthAgentsAgentIdRouteChildren)

interface AuthDetailsAgentsAgentIdRouteChildren {
  AuthDetailsAgentsAgentIdEmptyRoute: typeof AuthDetailsAgentsAgentIdEmptyRoute
  AuthDetailsAgentsAgentIdRunsRunIdRoute: typeof AuthDetailsAgentsAgentIdRunsRunIdRoute
}

const AuthDetailsAgentsAgentIdRouteChildren: AuthDetailsAgentsAgentIdRouteChildren =
  {
    AuthDetailsAgentsAgentIdEmptyRoute: AuthDetailsAgentsAgentIdEmptyRoute,
    AuthDetailsAgentsAgentIdRunsRunIdRoute:
      AuthDetailsAgentsAgentIdRunsRunIdRoute,
  }

const AuthDetailsAgentsAgentIdRouteWithChildren =
  AuthDetailsAgentsAgentIdRoute._addFileChildren(
    AuthDetailsAgentsAgentIdRouteChildren,
  )

interface AuthRouteChildren {
  AuthOrganizationsRoute: typeof AuthOrganizationsRouteWithChildren
  AuthSettingsRoute: typeof AuthSettingsRouteWithChildren
  AuthUpgradeRoute: typeof AuthUpgradeRoute
  AuthAgentsAgentIdRoute: typeof AuthAgentsAgentIdRouteWithChildren
  AuthAgentsNewRoute: typeof AuthAgentsNewRoute
  AuthIntegrationsExcelRoute: typeof AuthIntegrationsExcelRoute
  AuthAgentsIndexRoute: typeof AuthAgentsIndexRoute
  AuthDetailsAgentsAgentIdRoute: typeof AuthDetailsAgentsAgentIdRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthOrganizationsRoute: AuthOrganizationsRouteWithChildren,
  AuthSettingsRoute: AuthSettingsRouteWithChildren,
  AuthUpgradeRoute: AuthUpgradeRoute,
  AuthAgentsAgentIdRoute: AuthAgentsAgentIdRouteWithChildren,
  AuthAgentsNewRoute: AuthAgentsNewRoute,
  AuthIntegrationsExcelRoute: AuthIntegrationsExcelRoute,
  AuthAgentsIndexRoute: AuthAgentsIndexRoute,
  AuthDetailsAgentsAgentIdRoute: AuthDetailsAgentsAgentIdRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
